interface ArticleTextProps {
  text: string;
}

export const ArticleText = ({ text }: ArticleTextProps) => {
  return (
    <div className="prose mb-6">
      <p>{text}</p>
    </div>
  );
};
